const toPx = (value: number | string, baseFontSize = 16): number =>
  (typeof value === 'string'
    ? Number.parseFloat(value.replace('rem', ''))
    : value) * baseFontSize

export default toPx
